import { motion } from "framer-motion";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const CTA_URL = "https://manage.scan2ad.com/";

export const CtaSection = () => (
    <section className="bg-[#eefbf7] px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <Reveal>
            <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-gradient-to-br from-teal-800 via-teal-900 to-slate-950 px-6 py-16 shadow-2xl shadow-teal-950/30 sm:px-12 lg:px-16 lg:py-20">
                <div
                    aria-hidden
                    className="pointer-events-none absolute -left-24 -top-24 h-96 w-96 rounded-full bg-teal-400/20 blur-[100px]"
                />
                <div
                    aria-hidden
                    className="pointer-events-none absolute -bottom-32 -right-16 h-96 w-96 rounded-full bg-amber-400/15 blur-[100px]"
                />
                <div
                    aria-hidden
                    className="pointer-events-none absolute inset-0 opacity-[0.12]"
                    style={{
                        backgroundImage:
                            "radial-gradient(rgba(255,255,255,0.5) 1px, transparent 1px)",
                        backgroundSize: "30px 30px",
                    }}
                />

                <div className="relative grid items-center gap-12 lg:grid-cols-[1.2fr_0.8fr]">
                    <div>
                        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.22em] text-teal-300">
                            Get Started
                        </p>
                        <h2 className="font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
                            Ready to Create Your First Ad?
                        </h2>
                        <p className="mt-5 max-w-lg text-base leading-relaxed text-teal-100/80 sm:text-lg">
                            Scan the QR code or visit Scan2Ad to get started.
                        </p>

                        <div className="mt-9 flex flex-wrap items-center gap-5">
                            <motion.a
                                href={CTA_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="cta-create-first-ad-button"
                                whileHover={{ scale: 1.04 }}
                                whileTap={{ scale: 0.96 }}
                                className="group inline-flex items-center gap-2.5 rounded-full bg-white px-8 py-4 text-base font-semibold text-teal-900 shadow-xl shadow-black/20 transition-colors duration-200 hover:bg-teal-50"
                            >
                                Create Your First Ad
                                <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
                            </motion.a>
                            <a
                                href={CTA_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="cta-manage-link"
                                className="group inline-flex items-center gap-1.5 font-display text-lg font-semibold text-white"
                            >
                                manage.scan2ad.com
                                <ArrowUpRight className="h-4 w-4 text-teal-300 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                            </a>
                        </div>
                    </div>

                    <div className="flex justify-center lg:justify-end">
                        <motion.div
                            initial={{ rotate: 4 }}
                            whileHover={{ rotate: 0, scale: 1.03 }}
                            transition={{ type: "spring", stiffness: 200, damping: 18 }}
                            className="rounded-[2rem] bg-white p-6 shadow-2xl shadow-black/30 sm:p-8"
                            data-testid="cta-qr-code-graphic"
                        >
                            <img
                                src="/assets/qr.png"
                                alt="QR code linking to manage.scan2ad.com"
                                className="h-48 w-48 sm:h-56 sm:w-56"
                            />
                            <p className="mt-4 text-center text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
                                Scan to open Scan2Ad
                            </p>
                        </motion.div>
                    </div>
                </div>
            </div>
        </Reveal>
    </section>
);
